<template>
  <Documents :hasFilterMatter="true"/>
</template>

<script>
import Documents from "@/views/documents/Documents";

export default {
  name: "DocumentsMatter",
  components:{
    Documents
  }
}
</script>

<style>

@import "../style/style.css";

.last-edit {
  font-family: sans-serif;
}

.ant-btn-link, .text-indigo-600 {
  color: #3A3DBE
}

.docs-btn {
  padding: 0.5em 1em !important;
  border-radius: 4px !important;
}

[dir=ltr] .ant-modal-footer {
  display: none !important
}

.link-breadcrumb span {
  vertical-align: super
}

@media (max-width: 600px) {
  .btn_add {
    width: 70%;
    text-align: center;
    display: block;
    margin: auto;
  }
}

.ant-alert.ant-alert-info.ant-alert-with-description{
  border-radius: 3px !important;
}

.ant-alert-message{
  font-size: 1rem !important;
}

.ant-tag.ant-tag-has-color{
  border-radius: 3px !important;
}


</style>
